import {
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Chip,
  IconButton,
  CardActionArea,
} from "@mui/material";
import {
  Favorite as FavoriteIcon,
  Share as ShareIcon,
  Settings as SettingsIcon,
  Code as CodeIcon,
  Palette as PaletteIcon,
  ViewModule as ViewModuleIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * UI Components playground page.
 */
export function UIComponentsPage() {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        UI Components
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Component showcase and interactive examples
      </Typography>

      {/* Component Examples */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" gutterBottom>
          Component Examples
        </Typography>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Card>
              <CardActionArea onClick={() => navigate("/component/button-showcase")}>
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                    <CodeIcon color="primary" />
                    <Typography variant="subtitle1" fontWeight={500}>
                      Buttons
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    Button styles and variants
                  </Typography>
                  <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
                    <ArrowForwardIcon fontSize="small" color="action" />
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Card>
              <CardActionArea onClick={() => navigate("/component/card-layouts")}>
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                    <ViewModuleIcon color="primary" />
                    <Typography variant="subtitle1" fontWeight={500}>
                      Cards
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    Card layouts and patterns
                  </Typography>
                  <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
                    <ArrowForwardIcon fontSize="small" color="action" />
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Card>
              <CardActionArea onClick={() => navigate("/component/color-palette")}>
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                    <PaletteIcon color="primary" />
                    <Typography variant="subtitle1" fontWeight={500}>
                      Colors
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    Insight color palette
                  </Typography>
                  <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
                    <ArrowForwardIcon fontSize="small" color="action" />
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Interactive Example */}
      <Box>
        <Typography variant="h5" gutterBottom>
          Interactive Example
        </Typography>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Card>
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Typography variant="subtitle1" fontWeight={500}>
                    Counter Demo
                  </Typography>
                  <IconButton size="small">
                    <SettingsIcon />
                  </IconButton>
                </Box>
                <Box sx={{ textAlign: "center", my: 3 }}>
                  <Typography variant="h2" color="primary">
                    {count}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button variant="contained" onClick={() => setCount(count + 1)} fullWidth>
                    Increment
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => setCount(0)}
                    fullWidth
                  >
                    Reset
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Card>
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                    mb: 2,
                  }}
                >
                  <Typography variant="subtitle1" fontWeight={500}>
                    Feature Card
                  </Typography>
                  <IconButton size="small" color="primary">
                    <FavoriteIcon />
                  </IconButton>
                </Box>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Example card showing Insight theme styling with interactive elements.
                </Typography>
                <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                  <Chip label="React" size="small" color="primary" />
                  <Chip label="TypeScript" size="small" color="secondary" />
                  <Chip label="MUI" size="small" />
                </Box>
                <Box sx={{ display: "flex", gap: 1, justifyContent: "space-between" }}>
                  <Button size="small" variant="contained">
                    Action
                  </Button>
                  <IconButton size="small">
                    <ShareIcon />
                  </IconButton>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
